import React, { useState } from 'react';
import { TextField } from './TextInput';

export function TextFieldControlled() {
  const [value, setValue] = useState('');

  return <TextField label="Name" name="name" value={value} onChange={e => setValue(e.target.value)} />;
}
